import { saveAs } from 'file-saver';
import { HomeComponent } from '../home/home.component';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: "page-auxUrlDocs",
  templateUrl: "auxUrlDocs.component.html",
  styleUrls: ["./auxUrlDocs.component.css"]
})

export class auxUrlDocsComponent {

  public listDocs: Array<any> = [];
  public displayedColumns: string[] = ['num', 'nom','res', 'opt'];
  public dataSource = [];

  constructor(private dialog: MatDialog, private _router: Router, private spinner: NgxSpinnerService, private _userService: UserService,) {

  }
  ngOnInit(): void {
    this.spinner.show()

    this._userService.traerDocs().subscribe(
      response => {
        console.log(response)
        if (response.code == 200) {
          this.listDocs = response.data
          this.dataSource = this.listDocs
        }

        this.spinner.hide()
      }, error => {
        this.spinner.hide()
        console.log(error)
      }

    )
  }

  download(row): void {
    this.spinner.show()
    const name = row.fieldData.Nombre_documento != "" ? row.fieldData.Nombre_documento : "Sin título";
    
    this._userService.traerDocDownload(row.fieldData._ID, name)
    .then(blob => {
      console.log(blob)
      saveAs(blob, name + ".pdf");
     this.spinner.hide();
    })
    .catch(err => {console.error("download error = ", err); this.spinner.hide()});

  }

  cerrar_vista() {
    this._router.navigate([`/inicio`]);
  }

  moreInfo(doc:any): void {
    if (doc.fieldData.Tipo_documento.toLowerCase() === "pdf") {
      this.download(doc);
    }else if (doc.fieldData.Tipo_documento.toLowerCase() === "url") {
      window.open(doc.fieldData.URL);
    }
  }
}
